<template>
  <div class="col-12 col-md-auto product-meta order-3 product-parameter">
    <div class="p-3 p-lg-4 h-100">
      <form action="#" method="POST">
        <div class="my-4 py-2" v-if="!isInStock">
          <span class="in-stock">{{ $t("item_out_of_stock") }}</span>
        </div>
        <div class="my-4 py-2" v-else>
          <span class="in-stock">{{ $t("in_stock") }}</span>
        </div>
        <table class="table table-borderless align-middle" v-if="productGrouped.length">
          <thead>
            <tr>
              <th scope="col" style="padding: 0.3rem !important; text-align: center !important;">{{ $t("Product name") }}</th>
              <th scope="col" style="padding: 0.3rem !important; text-align: center !important;">{{ $t("Price") }}</th>
              <th scope="col" style="padding: 0.3rem !important; text-align: center !important;">{{ $t("number") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in productGrouped" :key="product.sku" class="product-qty">
              <td  style="padding: 0.3rem !important;">{{ product.name.split("|")[0] }} <span v-if="getNamePart2(product) !== ''">{{ getNamePart2(product) }}</span></td>
              <td  style="padding: 0.3rem !important;">{{
                formatCurrency(
                  product.price_range.minimum_price.final_price.value
                )
              }}</td>
              <td v-if="product.stock_status == 'IN_STOCK'"  style="padding: 0.3rem !important;">
                <div class="input-group">
                  <button class="btn" type="button" @click="quantityDown(product.sku)">-</button>
                  <input type="text" min="1" class="form-control" :value="productsQty[product.sku] ? productsQty[product.sku] : 0" name="quantity" ref="inputQuantity" disabled>
                  <button class="btn" type="button" @click="quantityUp(product.sku)">+</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <button
          type="button"
          v-if="isInStock"
          v-on:click="addToCart"
          v-bind:disabled="btnDisable"
          :style="buttonClass"
          class="btn btn-primary btn-lg d-block mx-auto mx-md-0 mb-4 px-4"
        >
          <ClientOnly><i class="fa-solid fa-basket-shopping me-2"></i></ClientOnly>
          {{ $t("add_to_cart") }}
        </button>
        <div
          class="deliery-info fw-bold"
          v-if="product.DeliveryTime != null"
          :style="'color: ' + product.DeliveryTime.color + '!important'"
          >{{ $t("delivery_time") }}: {{ product.DeliveryTime.long }}<sup>*</sup></div
        >
        <div class="mt-4">
          <strong class="d-block">{{ $t("product_information") }}:</strong>
          Model: {{ product.sku }}
        </div>
        <div class="product-extra-info" v-html="product.description.html"></div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Logger } from "@storefront/core/lib/logger";
import ClientOnly from "vue-client-only";

export default {
  name: "ProductParametersGrouped",
  components: {
    ClientOnly
  },
  props: {
    parameters: { type: Object },
    isInWishList: { type: Boolean },
  },
  computed: {
    ...mapGetters({
      product: "product/getCurrentProduct",
      compareList: "compare/getProductCompare",
      cartItems: "cart/getCartItems",
      GroupedProducts: "product/getCurrentGrouped"
    }),
    productBrand() {
      let productBrand = "";
      if (this.product.information_attributes) {
        const brand = this.product.information_attributes.find(
          (item) => item.attribute_code == "merk"
        );
        if (brand) {
          productBrand = brand.value;
        }
      }
      return productBrand;
    },
    productGrouped() {
      if (this.GroupedProducts) {
        return this.GroupedProducts.map((item) => item.product);
      }
      return [];
    },
    isInStock() {
      if (this.productGrouped.length) {
        return this.productGrouped.some(
          (product) => product.stock_status == "IN_STOCK"
        );
      }
      return this.product.stock_status == "IN_STOCK" ? true : false;
    },
    isProductInCompare() {
      return !!this.compareList.find(
        (product) => product.sku === this.product.sku
      );
    },
    btnDisable() {
      /*
      if (this.product.__typename == "ConfigurableProduct") {
        const retval = this.$store.getters["product/getCurrentChildSku"];
        if (retval != null) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
      */
      return false;
    },
    buttonClass() {
      if (this.btnDisable == true) {
        return "cursor: not-allowed;";
      } else {
        return "";
      }
    },
    finalPrice() {
      if (this.product.__typename == "ConfigurableProduct") {
        if (this.$store.getters["product/getCurrentChildSku"] != null) {
          const found = this.productConfig.variants.find((v) => {
            if (
              v.product.sku == this.$store.getters["product/getCurrentChildSku"]
            ) {
              return true;
            }
          });
          if (found != null) {
            return found.product.price_range.minimum_price.final_price.value.toFixed(
              2
            );
          }
        }
        if (
          this.product.price_range.minimum_price.final_price.value !=
          this.product.price_range.maximum_price.final_price.value
        ) {
          return (
            this.product.price_range.minimum_price.final_price.value.toFixed(
              2
            ) +
            " - " +
            this.product.price_range.maximum_price.final_price.value
              .toFixed(2)
              .replace(".", ",")
          );
        }
        return this.product.price_range.minimum_price.final_price.value.toFixed(
          2
        );
      }
      if (
        this.product.price_range.minimum_price.final_price.value !=
        this.product.price_range.maximum_price.final_price.value
      ) {
        return (
          this.product.price_range.minimum_price.final_price.value
            .toFixed(2)
            .replace(".", ",") +
          " - " +
          this.product.price_range.maximum_price.final_price.value
            .toFixed(2)
            .replace(".", ",")
        );
      }
      return this.product.price_range.minimum_price.final_price.value.toFixed(
        2
      );
    },
    regularPrice() {
      if (this.product.__typename == "ConfigurableProduct") {
        if (this.$store.getters["product/getCurrentChildSku"] != null) {
          const found = this.productConfig.variants.find((v) => {
            if (
              v.product.sku == this.$store.getters["product/getCurrentChildSku"]
            ) {
              return true;
            }
          });
          if (found != null) {
            return found.product.price_range.minimum_price.regular_price.value.toFixed(
              2
            );
          }
        }
        if (
          this.product.price_range.minimum_price.regular_price.value !=
          this.product.price_range.maximum_price.regular_price.value
        ) {
          return (
            this.product.price_range.minimum_price.regular_price.value.toFixed(
              2
            ) +
            " - " +
            this.product.price_range.maximum_price.regular_price.value
              .toFixed(2)
              .replace(".", ",")
          );
        }
        return this.product.price_range.minimum_price.regular_price.value.toFixed(
          2
        );
      }
      if (
        this.product.price_range.minimum_price.regular_price.value !=
        this.product.price_range.maximum_price.regular_price.value
      ) {
        return (
          this.product.price_range.minimum_price.regular_price.value
            .toFixed(2)
            .replace(".", ",") +
          " - " +
          this.product.price_range.maximum_price.regular_price.value
            .toFixed(2)
            .replace(".", ",")
        );
      }
      return this.product.price_range.minimum_price.regular_price.value.toFixed(
        2
      );
    },
    priceRange() {
      return this.product.price_range;
    },
    stockStatusClass() {
      return this.isInStock ? "in-stock" : "out-stock";
    },
  },

  data: () => ({
    quantity: 1,
    productsQty: {},
    totalQty: 0,
    rewardPoints: null,
    popup: false,
    addToNotifyModal: false,
    notifyModalProduct: null,
    addToCartModal: false,
    addToCompareModal: false,
  }),
  methods: {
    toggleIsInWishList() {
      this.$emit("changeIsInWishList");
    },
    formatCurrency(value) {
      var formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(value);
    },
    clickOk() {
      this.addToCartModal = false;
      this.$router.push("/checkout");
    },
    clickCancel() {
      this.addToCartModal = false;
      window.scrollTo(0, 0);
    },
    clickOkCompare() {
      this.addToCompareModal = false;
      this.$router.push("/compare");
    },
    clickCancelCompare() {
      this.addToCompareModal = false;
      window.scrollTo(0, 0);
    },
    async onCompareClick() {
      if (this.isProductInCompare == false) {
        await this.$store.dispatch("compare/addCompareProduct", {
          sku: this.product.sku,
        });
        this.addToCompareModal = true;
      } else {
        await this.$store.dispatch("compare/removeCompareProduct", {
          sku: this.product.sku,
        });
      }
    },
    closeNotifyModal() {
      this.notifyModalProduct = null;
      this.addToNotifyModal = false;
    },
    quantityUp(sku) {
      if (this.productsQty[sku]) {
        const updatedQty = this.productsQty[sku] + 1;
        this.productsQty = { ...this.productsQty, [sku]: updatedQty };
      } else {
        this.productsQty = { ...this.productsQty, [sku]: 1 };
      }
      this.totalQty = this.totalQty + 1;
    },
    quantityDown(sku) {
      if (this.productsQty[sku]) {
        const updatedQty = this.productsQty[sku] - 1;
        this.productsQty = { ...this.productsQty, [sku]: updatedQty };
        this.totalQty = this.totalQty - 1;
      }
    },
    addToNotify(sku) {
      const product = this.productGrouped.find((product) => product.sku == sku);
      this.notifyModalProduct = product;
      this.addToNotifyModal = true;
    },
    getGTMItems(product) {
      let items = {
        item_name: product.name,
        item_id: product.sku,
        quantity: this.quantity,
        price: this.regularPrice,
        item_brand: this.productBrand,
        discount: this.regularPrice - this.finalPrice,
      };
      return items;
    },
    async addToCart() {
      const addedProds = this.productGrouped
        .filter((product) => this.productsQty[product.sku])
        .map((product) => ({
          product: product,
          qty: this.productsQty[product.sku],
        }));
      if (addedProds.length == 0) {
        const msg = {
          type: "danger",
          title: this.$t("shopping_basket"),
          text: this.$t("bundle_product_qty"),
        };
        this.$store.dispatch("messages/sendMessage", { message: msg });
        return;
      }

      addedProds.forEach(async (element) => {
        if (element.product.__typename == "SimpleProduct") {
          const item =
            '{data: {sku: "' +
            element.product.sku +
            '", quantity:' +
            element.qty +
            "}}  ";
          let retval = await this.$store.dispatch("cart/addToCart", {
            type: element.product.__typename,
            item: item,
          });
          Logger.debug("retval", "addToCart", retval)();
          if (retval == false) {
            const msg = {
              type: "danger",
              title: this.$t("shopping_basket"),
              text: this.$t("not_add_product"),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
          } else {
            if (this.$gtm.enabled()) {
              Logger.debug("Watch Product", "product.vue", "CALLED")();
              window.dataLayer.push({
                event: "eec.add",
                ecommerce: {
                  add: {
                    currency: "EUR",
                    value: this.finalPrice,
                    products: [
                      {
                        name: this.product.name,
                        id: this.product.sku,
                        quantity: this.quantity,
                      },
                    ],
                  },
                },
              });
              if (this.$gtm.ga4Enabled) {
                window.dataLayer.push({
                  event: "add_to_cart",
                  ecommerce: {
                    add: {
                      currency: "EUR",
                      value: this.finalPrice,
                      items: [this.getGTMItems(element)],
                    },
                  },
                });
              }
            }
            this.addToCartModal = true;
            setTimeout(() => {
              this.addToCartModal = false;
            }, 5000);
            // this.$bvModal.show(`modal${this.product.sku}`);
          }
        }
      });
    },
    getNamePart2(product) {
      Logger.debug("getNamePart2", "Grouped", product.name.split("|"))();
      var part2 = "|" + product.name.split("|")[1];
      if (part2 !== "|undefined") {
        return part2;
      }
      return "";
    },
  },
};
</script>
